import Api from '@/api/api'

export default{
    packageList() {
        return Api.get('SaasAdmin/Module/GetModules');                     
    },
    getFetaure() {
        return Api.get('SaasAdmin/Feature/GetFeatures');                     
    },
    addModules(data){
        return Api.post('SaasAdmin/Module/SaveModule', data)
    },
    removePackage(id){
        return Api.delete('SaasAdmin/Module/DeleteModule/'+id)
    },
    getPackageById(id){
        return Api.get('SaasAdmin/Module/GetModuleByID/'+id)
    },
    updateModule(id,data){        
        return Api.put('SaasAdmin/Module/UpdateModule/'+id,data)
    }
}